<template>
  <div>
    <b-card class="">
      <b-card-title>
        <h2>Car Information</h2>
      </b-card-title>
      <table class="mt-1 w-100">
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="HashIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Manufacturer</span>
          </th>
          <td class="pb-50">
            {{ driverData.car ? driverData.car.make : '' }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="HashIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Car Number</span>
          </th>
          <td class="pb-50">
            {{ driverData.car ? driverData.car.carNumber : '' }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="FeatherIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Car Color</span>
          </th>
          <td class="pb-50">
            {{ driverData.car ? driverData.car.color : '' }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="AwardIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Car Model</span>
          </th>
          <td class="pb-50 text-capitalize">
            {{ driverData.car ? driverData.car.model : '' }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="CalendarIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Year</span>
          </th>
          <td class="pb-50 text-capitalize">
            {{ driverData.car ? driverData.car.year : '' }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="CalendarIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Car Type</span>
          </th>
          <td class="pb-50 text-capitalize">
            {{ driverData.car ? driverData.car.carType : '' }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="CalendarIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Seats</span>
          </th>
          <td class="pb-50 text-capitalize">
            {{ driverData.car ? driverData.car.noOfSeats : '' }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="CalendarIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Fuel Type</span>
          </th>
          <td class="pb-50 text-capitalize">
            {{ driverData.car ? driverData.car.fuelType : '' }}
          </td>
        </tr>
      </table>
      <hr>
      <b-card-title>Service Type</b-card-title>
      <b-table
        responsive
        :fields="tableColumns"
        :items="services"
        show-empty
        empty-text="No records found"
        class="my-2"
      />
    </b-card>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { BCard, BCardTitle, BTable } from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardTitle, BTable,
  },
  props: {
    driverData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const services = computed(() => props.driverData?.services)
    const tableColumns = [
      {
        label: 'Service Name',
        key: 'name',
      },
      {
        label: 'Class',
        key: 'class',
      },
    ]
    return {
      services,
      tableColumns,
    }
  },
}
</script>

<style>

</style>
